import "./Home.module.css";
import Header from "./sections/Header";
import LetsGetThisPartyStarted from "./sections/LetsGetThisPartyStarted";
import WhyChooseDJEntertainment from "./sections/WhyChooseDJEntertainment";
import ServicesWeOffer from "./sections/ServicesWeOffer";
import HearTheBeat from "./sections/HearTheBeat";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import LetsMakeSomeNoise from "./sections/LetsMakeSomeNoise";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "./sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LetsGetThisPartyStarted />
      <WhyChooseDJEntertainment />
      <ServicesWeOffer />
      <HearTheBeat />
      <WhatOurClientsSay />
      <LetsMakeSomeNoise />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}